import { createFileRoute, Outlet } from "@tanstack/solid-router"

export const Route = createFileRoute("/_authenticated/tablet/$orgId/_tablet/employees")({
  loader: () => ({ crumb: "Employees" }),
  component: RouteComponent
})

function RouteComponent() {
  return <Outlet />
}
